import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_HEAT_PUMP',
  GET: 'GET_HEAT_PUMP',
  CREATE: 'CREATE_HEAT_PUMP',
  EDIT: 'EDIT_HEAT_PUMP',
  DELETE: 'DELETE_HEAT_PUMP',
  DUPLICATE: 'DUPLICATE_HEAT_PUMP',
  CLEAR_ERROR: 'CLEAR_ERROR_HEAT_PUMP',
};

export const clearErrorHeatPump = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchHeatPumpByText = (text, page) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchHeatPump(pageSize, page, sorted, filtered, isPublic);
};

const searchHeatPump = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: Constants.API_HEAT_PUMP,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const listHeatPump = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchHeatPump(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const createHeatPump = (name, typeId, COP, description, image) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('type_id', typeId);
  formData.set('COP', COP);
  formData.set('description', description);
  if (image) formData.set('image', image, `heat_pump_${new Date().valueOf()}`);

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_HEAT_PUMP,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editHeatPump = (id, name, typeId, COP, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (typeId) formData.set('type_id', typeId);
  if (COP) formData.set('COP', COP);
  if (typeof(description) === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `heat_pump_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_HEAT_PUMP}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteHeatPump = heatPumpId => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_HEAT_PUMP}${heatPumpId}/`,
    })
      .then(() => ({ id: heatPumpId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateHeatPump = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_HEAT_PUMP}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/heat_pump/heat_pump_actions.js